var rwm;
if (!rwm) {
    rwm = {};
}

$.extend(rwm,
    /**
     * @lends rwm
     */
    {
        /**
         * @namerwmace
         * @description Header Scroll Function
         */
        header: {
            /**
             * @type {function}
             * @description initialize Header
             */
            init: function () {               
                var $window = $(window),
                    $header = $('.header'),
                    $page_wrapper = $('.page-wrapper'),
                    top = $header.height(),                    
                    lastY = 0;

                FastClick.attach(document.body);

                $(window).on( 'DOMMouseScroll mousewheel', function ( event ) {
                    if( event.originalEvent.detail > 0 || event.originalEvent.wheelDelta < 0 ) { //alternative options for wheelData: wheelDeltaX & wheelDeltaY
                        //scroll down
                        if( $window.scrollTop() > top) {
                            $header.addClass('header--pageScrolled');
                            $page_wrapper.addClass('page-wrapper--pageScrolled');
                        }
                    } else {
                        //scroll up
                        if( $window.scrollTop() < top + 100) {
                            $header.removeClass('header--pageScrolled');
                            $page_wrapper.removeClass('page-wrapper--pageScrolled');                        
                        }
                    }
                });

                if( $window.scrollTop() > top) {
                    $header.addClass('header--pageScrolled');
                }

                $('.header .btn-search').click(function(){
                    $('.stripe--search').slideToggle();
                    $('.header.header--fixed').toggleClass('header--noShadow');
                });

                

            }
        }
    }
);

$(rwm.header.init);


